import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { LangContext } from "../LangContext.jsx";
const fieldTypes = [
    {
        id: 'Total',
        title: 'Total',
        placeholder: 'Total',
        icon: 'fa-font',
        document_field_type: 'text',
        index:0,
    },
    {
        id: 'Sub_Total',
        title: 'Sub_Total',
        placeholder: 'Sub_Total',
        icon: 'fa-font',
        document_field_type: 'text',
        index:1
    },
    {
        id: 'Descuento',
        title: 'Descuento',
        placeholder: 'Descuento',
        icon: 'fa-font',
        document_field_type: 'text',
        index:1
    },
    {
        id: 'Fecha',
        title: 'Fecha',
        placeholder: 'Fecha',
        icon: 'fa-font',
        document_field_type: 'text',
        index:2
    },
    {
        id: 'Folio',
        title: 'Folio',
        placeholder: 'Folio',
        icon: 'fa-font',
        document_field_type: 'text',
        index:3
    },
    {
        id: 'Lugar_Expedicion',
        title: 'Lugar_Expedicion',
        placeholder: 'Lugar_Expedicion',
        icon: 'fa-font',
        document_field_type: 'text',
        index:5
    },
    {
        id: 'Metodo_Pago',
        title: 'Metodo_Pago',
        placeholder: 'Metodo_Pago',
        icon: 'fa-font',
        document_field_type: 'text',
        index:5
    },

    {
        id: 'Moneda',
        title: 'Moneda',
        placeholder: 'Moneda',
        icon: 'fa-font',
        document_field_type: 'text',
        index:5
    },

    {
        id: 'No_Certificado',
        title: 'No_Certificado',
        placeholder: 'No_Certificado',
        icon: 'fa-font',
        document_field_type: 'text',
        index:5
    },
    {
        id: 'Tipo_Cambio',
        title: 'Tipo_Cambio',
        placeholder: 'Tipo_Cambio',
        icon: 'fa-font',
        document_field_type: 'text',
        index:5
    },
    {
        id: 'Exportacion',
        title: 'Exportacion',
        placeholder: 'Exportacion',
        icon: 'fa-font',
        document_field_type: 'text',
        index:5
    },
    {
        id: 'Version',
        title: 'Version',
        placeholder: 'Version',
        icon: 'fa-font',
        document_field_type: 'text',
        index:5
    },
    {
        id: 'Serie',
        title: 'Serie',
        placeholder: 'Serie',
        icon: 'fa-font',
        document_field_type: 'text',
        index:5
    },
    {
        id: 'Forma_Pago',
        title: 'Forma_Pago',
        placeholder: 'Forma_Pago',
        icon: 'fa-font',
        document_field_type: 'text',
        index:5
    },

];
class DocumentFieldsCFDINomina extends Component {
    constructor(props) {
        super();
        this.state = {
            indexSelected: null,
            fields: fieldTypes,
            all_fields:fieldTypes
        };
        this.removeIndex = this.removeIndex.bind(this);
    }

    componentWillReceiveProps(props) {
        if (props.selected_fields != null) {
            this.setState({
                indexSelected: null,
                fields: props.selected_fields
            })
        }
    }

    onDragEnd = result => {
        if (!result.destination) return;
        for (var i = 0; i < this.state.fields.length; i++) {
            if(this.state.fields[i].index == result.source.index){
                return false;
            }
        }
        if (result.destination.droppableId == 'newField') {
            try {
                const f = {
                    id:fieldTypes[result.source.index].id,
                    document_field_type: fieldTypes[result.source.index].document_field_type,
                    title: fieldTypes[result.source.index].title,
                    index: fieldTypes[result.source.index].index,
                    placeholder: "",
                    required: false
                }
                this.setState(prevState => ({
                    fields: [...prevState.fields, f],
                    indexSelected: prevState.fields.length
                }))
            } catch (error) {
                console.log(error);
            }
        }
    }

    removeIndex(e, index) {
        e.stopPropagation();
        const fields = [...this.state.fields];
        fields.splice(index, 1);
        this.setState({ indexSelected: null, fields: fields });
    }

    render() {
        return (
            <div>
                <div className="card mt-6 p-9">
                    <strong className="mb-3">Información que se extrae del CFDI de tipo Nomina</strong>
                    <div className="card mt-3 p-9 bg-light-light">
                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="fields">
                                {(provided) => (
                                    <div className="row align-left" {...provided.droppableProps} ref={provided.innerRef}>
                                        <div className="col-sm-8">
                                            {this.state.fields.map(({id, document_field_type, title}, index) => {
                                                return (<div key={index} className="mb-2">
                                                    <span>
                                                        <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i>
                                                    </span>
                                                    <span className="d-inline-block">
                                                        {title.replace('_', ' ')}
                                                    </span>
                                                </div>);
                                            })}

                                        </div>
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
            </div>
        );
    }
}

export default DocumentFieldsCFDINomina;

if (document.getElementById('DocumentFieldsCFDINomina')) {
    ReactDOM.render(<DocumentFieldsCFDINomina />, document.getElementById('DocumentFieldsCFDINomina'));
}
